<template>
  <v-dialog
    overlay-color="black"
    overlay-opacity=".7"
    v-model="visibility"
    @click:outside="closeModal"
    @keydown.esc="closeModal"
  >
    <v-card
      color="transparent"
      class="background-darkest-blur modal-border mb-1"
    >
      <v-card-title class="justify-center py-2 px-0">
        <v-row justify="start">
          <v-col cols="2" align-self="center" class="d-flex justify-start">
            <v-btn icon @click="closeModal">
              <v-icon class="success--text font-weight-bolder"
                >mdi-close</v-icon
              >
            </v-btn>
          </v-col>
          <v-col
            cols="8"
            align-self="center"
            class="d-flex justify-center border-bottom-success-1px"
          >
            <span class="secondary--text font-size-medium-small">
              {{ editProfileFieldVerification | verificationFieldTranslate }}
              Verification</span
            >
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="transparent pa-0 rounded px-3">
        <v-container fluid class="flex-xy-centering pa-0">
          <!--    Notice-->
          <transition
            name="animate__fadeIn"
            enter-active-class="animate__animated animate__fadeIn"
          >
            <v-container class="pt-5" cols="12" v-if="page === 'notice'">
              <v-row justify="center">
                <v-col cols="12" class="text-center">
                  <span class="font-weight-bold accent--text">
                    Wish to Verify Your
                    {{
                      editProfileFieldVerification | verificationFieldTranslate
                    }}?
                  </span>
                </v-col>
                <v-col cols="12" class="text-center">
                  <span class="font-weight-bold accent--text text-caption">
                    Code will be sent to
                    {{
                      editProfileFieldVerification === "email"
                        ? getUserInfo.email
                        : editProfileFieldVerification === "phoneNumber"
                        ? getUserInfo.phoneNumber
                        : ""
                    }}
                  </span>
                </v-col>
                <v-col cols="12" class="text-center">
                  <span
                    class="font-weight-bold success--text text-caption cursor-pointer"
                    @click="closeModal"
                  >
                    (Change
                    {{
                      editProfileFieldVerification | verificationFieldTranslate
                    }})
                  </span>
                </v-col>
              </v-row>
            </v-container>
          </transition>

          <!-- End notice -->

          <!--    Code enter-->
          <transition
            name="animate__fadeIn"
            enter-active-class="animate__animated animate__fadeIn"
          >
            <v-container class="pt-5" v-if="page === 'enterCode'">
              <v-row justify="center">
                <v-col cols="6" class="text-center">
                  <span class="font-weight-bold accent--text text-body-1">
                    Enter Code:
                  </span>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="8" class="text-center">
                  <v-form fluid ref="form" v-model="valid">
                    <v-text-field
                      rounded
                      outlined
                      hide-details
                      dense
                      dark
                      color="success"
                      class="primary-autofill modal-inputs-background text-center"
                      v-model="validationCode"
                      :rules="[rules.minLength, rules.required]"
                    >
                    </v-text-field>
                  </v-form>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col
                  cols="12"
                  class="text-center success--text font-weight-bold text-caption"
                >
                  <span>
                    Didn't receive any code?
                    <br />
                    Wait {{ codeVerificationRemainingTime | formatTime }}
                  </span>
                </v-col>
              </v-row>
            </v-container>
          </transition>

          <!--    End code enter-->
        </v-container>
      </v-card-text>
      <v-card-actions class="transparent mb-2">
        <v-row no-gutters justify="center">
          <v-col cols="6">
            <TwoLayerButton
              v-if="page === 'notice'"
              :outer-container-class="'outer-button-layer'"
              :inner-container-class="'inner-button-layer py-2 px-0 font-size-xs'"
              :button-text="'Send Code'"
              :primary-color="'primary'"
              :loading="requestPending"
              @button-clicked="
                requestVerification(editProfileFieldVerification)
              "
            />
            <TwoLayerButton
              v-else-if="page === 'enterCode'"
              :outer-container-class="'outer-button-layer'"
              :inner-container-class="'inner-button-layer py-2 px-0 font-size-xs'"
              :button-text="'Submit'"
              :primary-color="'primary'"
              :loading="requestPending"
              :disable-theme-active="!valid"
              :disable-button="!valid"
              @button-clicked="verify(editProfileFieldVerification)"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import Services from "@/services/user-services.js";
import toastServices from "@/services/toast";
import TwoLayerButton from "@/components/Helper/TwoLayerButton";

export default {
  name: "EditProfileVerification",
  components: { TwoLayerButton },
  props: {
    visibility: Boolean,
    editProfileFieldVerification: String,
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
  },
  data() {
    return {
      page: "notice",
      requestPending: false,
      validationCode: "",
      valid: true,
      codeVerificationRemainingTime: "",
      rules: {
        required: (v) => !!v || "Required.",
        minLength: (v) => v.length >= 3 || "Min 3 characters",
      },
    };
  },
  filters: {
    verificationFieldTranslate: (field) => {
      return field === "email"
        ? "Email"
        : field === "phoneNumber"
        ? "Phone Number"
        : "";
    },
  },
  methods: {
    closeModal() {
      this.$emit("toggleVisibility");
      clearInterval(this.countDownInterval);
      this.setDefaultPageValues();
    },
    countDownTimer() {
      if (this.countDownInterval) clearInterval(this.countDownInterval);
      this.countDownInterval = setInterval(() => {
        this.codeVerificationRemainingTime =
          this.codeVerificationRemainingTime - 1000;
        if (this.codeVerificationRemainingTime < 0) {
          this.codeVerificationRemainingTime = "00:00:00";
          clearInterval(this.countDownInterval);
          this.changePage("notice");
        }
      }, 1000);
    },
    /**
     * Request URL = /accounts/verify-{email || phone}
     * @param field
     */
    verifyCode(field) {
      this.requestPending = true;
      Services.post(`accounts/verify-${field}`, {
        code: this.validationCode,
      }).then(
        (res) => {
          this.requestPending = false;
          toastServices.typeSuccess(res.body.message);
          this.getUserInfoApi();
          this.closeModal();
        },
        (error) => {
          Services.apiError(error.body.message, error.status);
          this.requestPending = false;
        }
      );
    },
    verify(which) {
      if (which === "phoneNumber") this.verifyCode("phone");
      else if (which === "email") this.verifyCode("email");
    },
    changePage(toPage) {
      this.page = toPage;
    },
    /**
     * Request URL = /accounts/request-{email || phone}-verification
     * @param field
     */
    requestVerificationApi(field) {
      this.requestPending = true;
      // Determine the method based on the field value
      const method = field === "email" ? "post" : "get";

      // Create a function to handle the response
      const handleResponse = (res) => {
        toastServices.typeSuccess(res.body.message);
        this.codeVerificationRemainingTime = res.body.remainingTime;
        this.changePage("enterCode");
        this.countDownTimer();
        this.requestPending = false;
      };

      // Create a function to handle the error
      const handleError = (error) => {
        Services.apiError(error.body.message, error.status);
        this.requestPending = false;
      };

      // Use the determined method to make the request
      if (method === "get") {
        Services.get(`accounts/request-${field}-verification`).then(
          handleResponse,
          handleError
        );
      } else {
        Services.post(`accounts/request-${field}-verification`, {
          email: this.getUserInfo.email,
        }).then(handleResponse, handleError);
      }
    },
    requestVerification(which) {
      if (which === "phoneNumber") this.requestVerificationApi("phone");
      else if (which === "email") this.requestVerificationApi("email");
    },
    setDefaultPageValues() {
      //because of the close modal animation, we need to wait a little before setting default info.
      setTimeout(() => {
        this.changePage("notice");
        this.validationCode = "";
      }, 100);
    },
  },
};
</script>

<style scoped>
.modal-header {
  width: 100%;
  height: 55px;
  font-size: 1.3rem;
  color: #ffffff;
  text-align: center;
  padding: 15px;
}
</style>
